export class Timer {
  t0 = new Date();
  getElapsedTime = (): number => {
    return new Date().getTime() - this.t0.getTime();
  };
}
